module.exports = __webpack_public_path__ + "media/images/lb/159-24660ca4a69d82bd15b1e3883027ae8d.svg";